import { NgModule } from '@angular/core';
import { LegacyShiftComponent } from './legacy-shift.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/*';
import { TranslateModule } from '@ngx-translate/core';
import { ShiftDateDiffPipe } from './shift-date-diff.pipe';
import { LegacyShiftEditorComponent } from './shift-editor/legacy-shift-editor.component';
import { LegacyShiftUpdateComponent } from './shift-update/legacy-shift-update.component';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';

/**
 * @deprecated
 */
@NgModule({
    declarations: [
        LegacyShiftComponent,
        ShiftDateDiffPipe,
        LegacyShiftEditorComponent,
        LegacyShiftUpdateComponent
    ],
    imports: [CommonModule, SharedModule, TranslateModule, ZenithComponentsModule],
    exports: [
        LegacyShiftComponent,
        LegacyShiftUpdateComponent
    ]
})
export class LegacyShiftModule {

}
